/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { isolateComponent } from '@zapier/common-utils';
import { Link } from '@zapier/design-system';

const rootStyles = css`
  display: inline-block;

  a {
    text-decoration: none;
  }
`;

export const JobsCta = () => {
  return (
    <div css={rootStyles}>
      We’re hiring — <Link href="/about/">work remotely</Link>
    </div>
  );
};
